/** Merge admin copy overrides and validation rules into a built step array. */
import { findCatalogStep } from './terminal-flow-catalog.js';
import { applyFlowValidationRules } from './terminal-flow-validation.js';

let overrides = {};

export function setTerminalFlowOverrides(obj) {
  overrides = obj && typeof obj === 'object' ? obj : {};
}

export function getTerminalFlowOverrides() {
  return overrides;
}

export function overrideStorageKey(flowId, stepKey) {
  return `${flowId}.${stepKey}`;
}

function wildcardToRegExp(pattern) {
  const escaped = pattern.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  return new RegExp(`^${escaped.replace(/\\\*/g, '[^:]+')}$`);
}

function lookupOverride(flowId, stepKey) {
  const exact = overrideStorageKey(flowId, stepKey);
  if (overrides[exact]) return overrides[exact];

  const prefix = `${flowId}.`;
  for (const [key, val] of Object.entries(overrides)) {
    if (!key.startsWith(prefix)) continue;
    const pattern = key.slice(prefix.length);
    if (!pattern.includes('*')) continue;
    if (wildcardToRegExp(pattern).test(stepKey)) return val;
  }
  return null;
}

function applyOverrideToStep(step, patch, flowId) {
  if (!patch) return step;
  const next = { ...step };
  if (patch.ask != null && patch.ask !== '') next.ask = patch.ask;
  if (patch.hint != null && patch.hint !== '') next.hint = patch.hint;
  if (patch.hint === '') next.hint = undefined;
  if (patch.choices != null && patch.choices !== '') {
    const baseHint = next.hint || '';
    next.hint = baseHint ? `${baseHint}\n${patch.choices}` : patch.choices;
  }
  if (patch.optional != null && flowId) {
    const catalog = findCatalogStep(flowId, step.key);
    if (catalog?.behaviorEditable && !catalog?.locked && !step._custom) {
      next.optional = !!patch.optional;
    }
  }
  return next;
}

/** Apply stored overrides to a built step array. */
export function applyFlowStepOverrides(flowId, steps) {
  if (!flowId || !Array.isArray(steps) || !steps.length) return steps;
  if (!Object.keys(overrides).length) return steps;
  return steps.map((step) => applyOverrideToStep(step, lookupOverride(flowId, step.key), flowId));
}

/** Copy overrides + admin validation rules (call after injectCustomSteps when needed). */
export function prepareFlowSteps(flowId, steps) {
  if (!flowId || !Array.isArray(steps)) return steps;
  return applyFlowValidationRules(flowId, applyFlowStepOverrides(flowId, steps));
}
